export default __webpack_public_path__ + "static/media/codesGuidesThumb.dbc85291.png";